/**
 * @file 확장소재 한글 명칭
 * @see https://wiki.daumkakao.com/pages/viewpage.action?pageId=771171166
 */

export const ReportAssetTypes = {
  BASIC: '기본 소재',
  THUMBNAIL: '썸네일',
  MULTI_THUMBNAIL: '멀티썸네일',
  ADDITIONAL_TITLE: '추가제목',
  ADDITIONAL_LINK: '부가링크',
  SUBJECT: '말머리',
  PRICE_TABLE: '가격테이블',
  CALCULATE: '계산하기',
  PHONE_NUMBER: '전화번호',
  TALK_CHANNEL: '카카오톡채널',
  THUMBNAIL_RECOMMEND: '추천소재',
  THUMBNAIL_CUSTOM: '맞춤소재',
}
